'use client'
import React, { useState, useEffect } from 'react'
import { getEnvironmentConfig, type EnvironmentConfig } from '@/utilities/getEnvironment'

export const EnvironmentIcon: React.FC = () => {
  const [envConfig, setEnvConfig] = useState<EnvironmentConfig | null>(null)

  useEffect(() => {
    // Only run on client after mount
    setEnvConfig(getEnvironmentConfig())
  }, [])

  const iconColor = envConfig?.showBadge ? envConfig.color : '#fff'

  return (
    <div
      style={{
        width: '16px',
        height: '16px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        fontSize: '12px',
        fontWeight: 'bold',
        color: iconColor,
        borderRadius: '6px',
      }}
    >
      RS-42
    </div>
  )
}

export default EnvironmentIcon
